var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 32,
    viewBox: "0 0 180 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H166.627C166.997 0.5 167.354 0.636857 167.629 0.884245L178.567 14.8842C179.23 15.4802 179.23 16.5198 178.567 17.1158L167.629 31.1158C167.354 31.3631 166.997 31.5 166.627 31.5H5C2.51472 31.5 0.5 29.4853 0.5 27V5Z",
    stroke: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstStepIcon);
export default __webpack_public_path__ + "static/media/first-step-icon.1c3f7023b5d76132482e5b67949eeae1.svg";
export { ForwardRef as ReactComponent };